import { render } from "./MLinkButton.vue?vue&type=template&id=38851085"
import script from "./MLinkButton.vue?vue&type=script&lang=js"
export * from "./MLinkButton.vue?vue&type=script&lang=js"

import "./MLinkButton.vue?vue&type=style&index=0&id=38851085&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__